import React, { useCallback, useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '#app/hooks/useAppStore';
import { Container, Links, Popup } from './styles';
import { useDropdown } from '../hooks/useDropdown';
import { handleRouteClick } from '#app/interface/cabinet/header/Dropdown/utils/handleRouteClick';

/**
 * Обработчик клика по ссылке
 */

/**
 * Компонент Dropdown (Выпадающее меню)
 */
// Dropdown.tsx
const DropdownComponent = ({
  links = [],
  children,
  id,
  containerId,
  width,
  style,
  disableXPositioning = false,
  dropdownTop = '8px',
}) => {
  const client = useAppSelector((s) => s.interfaceComponents.client);
  const data = useAppSelector((s) => s.auth?.data);
  const location = useLocation();
  const navigate = useNavigate();

  const { isOpen, position, dropdownRef, initiatorRef, handleMouseOver, handleMouseLeave } =
    useDropdown(disableXPositioning, dropdownTop);

  const handleLinkClick = useCallback(
    (e, item) => {
      // preventDefault нужен только для ссылок (<a>), для button он не нужен и может мешать
      // Если есть link, значит это ссылка, нужен preventDefault
      if (item.link) {
        e.preventDefault();
      }
      if (item.onClick) {
        item.onClick(e);
        return;
      }
      handleRouteClick(item.link, client, data, navigate);
    },
    [client, data, navigate]
  );

  const renderLink = useMemo(() => {
    return (item, key) => {
      const isActive = location.pathname === item.link ? 'active' : '';
      const { id, text, link } = item;

      const sharedProps = {
        id,
        className: isActive,
      };
      // TODO: Через button не работает открытие классовых компонентов
      // Если нет link и есть onClick, рендерим button
      // if (!link && typeof item.onClick === 'function') {
      //   return (
      //       <button
      //           key={key}
      //           id={id}
      //           className={isActive}
      //           onClick={(e) => {
      //             // Для button не нужен preventDefault, вызываем onClick напрямую
      //             e.stopPropagation();
      //             item.onClick(e);
      //           }}
      //       >
      //         {text}
      //       </button>
      //   );
      // }
      // Если есть onClick и есть link, рендерим <a> с обработчиком
      if (typeof item.onClick === 'function') {
        return (
          <a key={key} {...sharedProps} href={link} onClick={(e) => handleLinkClick(e, item)}>
            {text}
          </a>
        );
      }

      // Если есть link без onClick, рендерим <Link>
      return (
        <Link key={key} {...sharedProps} to={link} onClick={(e) => handleLinkClick(e, item)}>
          {text}
        </Link>
      );
    };
  }, [location.pathname, handleLinkClick]);

  return (
    <Container
      ref={initiatorRef}
      style={style}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    >
      {children}

      {links.length > 0 && (
        <Popup
          $open={isOpen}
          $position={position}
          ref={dropdownRef}
          onMouseEnter={handleMouseOver}
          onMouseLeave={handleMouseLeave}
          id={containerId}
          width={width}
        >
          <Links id={id}>{links.map((link, i) => renderLink(link, i))}</Links>
        </Popup>
      )}
    </Container>
  );
};

const areEqual = (prevProps, nextProps) =>
  prevProps.links === nextProps.links &&
  prevProps.disableXPositioning === nextProps.disableXPositioning &&
  prevProps.dropdownTop === nextProps.dropdownTop;

export default React.memo(DropdownComponent, areEqual);
